import { useEffect } from 'react';
import { logEvent } from "firebase/analytics";
import { analytics } from '../../../firebase';

export default function DutyVigilRedirect() {
  useEffect(() => {
    // 1. Log the redirect event to Firebase Web Analytics
    logEvent(analytics, 'app_share_redirect_clicked', {
      app_name: 'DutyVigil',
      platform: 'Desktop',
      timestamp: new Date().toISOString()
    });

    // 2. Define the Download/Product page URL
    // Since it's a desktop app, this might point to a GitHub release or a specific landing page
    const downloadUrl = 'https://tattvadynamics.com/#dutyvigil';

    // 3. Perform the redirect with a slight delay
    const timer = setTimeout(() => {
      window.location.href = downloadUrl;
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500 mx-auto mb-4"></div>
        <p className="text-gray-400">Redirecting to DutyVigil...</p>
      </div>
    </div>
  );
}
